import { Redirect, Route, Switch } from 'react-router-dom';

import { CheckoutContainer } from 'app/checkout/CheckoutContainer';

import { AppRoute } from './AppRoute.enum';
import { ProducerCheckoutContainer } from 'app/producerCheckout/ProducerCheckoutContainer';

export const AppRoutes = () => {
  return (
    <Switch>
      <Route path={AppRoute.checkout}>
        <CheckoutContainer />
      </Route>
      <Route path={AppRoute.nameCheckCheckout}>
        <ProducerCheckoutContainer />
      </Route>
      <Redirect to={AppRoute.checkout} />
    </Switch>
  );
};
